function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="30" height="30" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M50 27.08c-20.832 0-35.418 22.918-35.418 22.918S25.207 72.916 50 72.916c25 0 35.418-22.918 35.418-22.918S71.043 27.08 50 27.08m0 37.5c-8.125 0-14.582-6.457-14.582-14.582S41.875 35.416 50 35.416s14.582 6.457 14.582 14.582S58.125 64.58 50 64.58" /><path d="M56.25 50c0 3.453-2.797 6.25-6.25 6.25s-6.25-2.797-6.25-6.25 2.797-6.25 6.25-6.25 6.25 2.797 6.25 6.25" /></svg>;
});